import { observer } from 'mobx-react-lite'
import { ActionCenterComponent } from 'app/components/action-center/ActionCenterComponent'
import { useActionCenter } from 'app/components/action-center/useActionCenter'

const ActionCenterPage = observer(function ActionCenterPage() {
  const props = useActionCenter()
  return <ActionCenterComponent {...props} />
})

export default ActionCenterPage
